export default __webpack_public_path__ + "static/media/label-pescatori.9b016284.png";